import { ACTIVE_CORGANIZATION } from './apiModules'

import { post } from '@/utils/request'
export function getDecentralizedOrg(params) {
  return post(`${ACTIVE_CORGANIZATION}/getFeatureOrgRatio`, params)
}

export function getDecentralizedOrgList(params) {
  return post(`${ACTIVE_CORGANIZATION}/getFeatureOrgInfo`, params)
}
